import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";

import { Breadcrumbs } from "~/components/admin/Breadcrumbs";
import { OrganizationIcon } from "~/components/admin/Icons";
import { OrganizationsTable } from "~/components/admin/OrganizationsTable";
import { PageHeader } from "~/components/admin/PageHeader";
import { QueryState } from "~/components/QueryState";
import { TRPCClientErrorDisplay } from "~/components/TRPCClientErrorDisplay";
import { Spinner } from "~/components/ui/Spinner";
import { useTRPC } from "~/lib/trpc";

export const Route = createFileRoute("/_authenticated/admin/organizations/")({
  component: OrganizationsIndexPage,
});

function OrganizationsIndexPage() {
  const trpc = useTRPC();
  const query = useQuery(trpc.salesforce.organizations.list.queryOptions());

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumbs={
          <Breadcrumbs>
            <Link to="/admin">Admin</Link>
            <span>Organizations</span>
          </Breadcrumbs>
        }
        icon={OrganizationIcon}
        title="Organizations"
      />

      <QueryState
        result={query}
        loading={<Spinner size="lg" />}
        error={(error) => <TRPCClientErrorDisplay error={error} />}
      >
        {(data) => <OrganizationsTable organizations={data} />}
      </QueryState>
    </div>
  );
}
